import type { SVGProps } from 'react';

/** Germany — horizontal black/red/gold tricolour. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const DeFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="10" fill="#000" />
        <rect y="10" width="60" height="10" fill="#DD0000" />
        <rect y="20" width="60" height="10" fill="#FFCE00" />
    </svg>
);
